import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Error404 } from 'views/shared';
import { AppContext } from 'contexts';
import { Pano } from './components';

interface Params {
  listingId: string;
  esoft_order_id?: string;
}

function Home() {
  const { listingId, esoft_order_id } = useParams<Params>();

  const appContext = useContext(AppContext);
  const { hasError, setListingId, getCurrentMarker, setCurrentMarker } = appContext;
  const [panoInstance, setPanoInstance] = useState(null);

  const image = getCurrentMarker();

  async function setPanoviewData() {
    setCurrentMarker(0);
    setListingId(listingId, Number(esoft_order_id));
    setPanoInstance({ p: null, v: null, rot_interval_id: null });
  }

  useEffect(() => {
    setPanoviewData();
  }, []);

  return (
    <div className='page'>
      {!hasError ? <Pano instance={panoInstance} image={image} /> : <Error404 />}
    </div>
  );
}

export default Home;
